import { Instagram, Facebook } from "lucide-react";

const LOGO_URL =
  "https://static.wixstatic.com/media/58bce5_ff49195ee84941b3af580db450290b82~mv2.png";

const Footer = () => {
  return (
    <footer className="px-2.5 pb-2.5">
      <div className="rounded-2xl bg-[var(--card-dark)] border border-white/10 px-6 py-12 sm:px-12 sm:py-16">
        <div className="flex items-center gap-4 mb-16">
          <img src={LOGO_URL} alt="New Idea Architect logó" className="h-14 w-14 sm:h-16 sm:w-16 object-contain" />
          <span
            className="text-white text-3xl sm:text-5xl font-extralight tracking-wide"
            style={{ fontFamily: "'Inter Tight', sans-serif", fontWeight: 200 }}
          >
            New Idea Architect
          </span>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-10">
          <div className="text-white/90 text-base leading-7">
            <a href="tel:+36209681179" className="block hover:text-[var(--accent)] transition-colors">+36 20 968 1179</a>
            <a href="mailto:info@nia.hu" className="block hover:text-[var(--accent)] transition-colors">info@nia.hu</a>
            <p>1111 Budapest</p>
            <p>Lágymányosi utca 12</p>
          </div>

          <div className="flex flex-col sm:items-end gap-2">
            <a
              href="https://www.newideaarchitect.com/english-privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/90 underline underline-offset-2 hover:text-[var(--accent)] transition-colors text-sm"
            >
              ÁSZF
            </a>
            <a
              href="https://www.newideaarchitect.com/accessibility-statement"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/90 underline underline-offset-2 hover:text-[var(--accent)] transition-colors text-sm"
            >
              Adatkezelési tájékoztató
            </a>
            <div className="flex gap-3 mt-2">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-white hover:text-[var(--accent)] transition-colors"
              >
                <Instagram size={22} />
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-white hover:text-[var(--accent)] transition-colors"
              >
                <Facebook size={22} />
              </a>
            </div>
            <p className="text-white/60 text-sm mt-2">© 2015 New Idea Architect</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
